import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-NoContent',
  templateUrl: './NoContent.component.html'
})
export class NoContentComponent implements OnInit {
  @Input() msg:any="";
  @Input() minheight:any="";
  constructor() { }

  ngOnInit() {
  }

}
